import i1 from './PROSIXRPTRimg/i1.jpg';
import i2 from './PROSIXRPTRimg/i2.jpg';
import i3 from './PROSIXRPTRimg/i3.jpg';

import { getPrice } from '../../../../../../Prices';

const PROSIXRPTR = () => {
    const device = {
        title: 'Wireless Repeater',
        model: 'PROSIXRPTR',
        sku: ['PROSIXRPTR'],
        modelViewImage: i3,
        image: [i1, i2],
        shortDescription: 'Extends the wireless range of Honeywell ProSeries devices for larger installations or challenging environments.',
        price: getPrice('PROSIXRPTR'),
        group: 'accessory',
        checkListKeyword: [],
        infoHeader: "Wireless Signal Repeater",
        spec: [
            { row1: 'Model:', row2: 'PROSIXRPTR' },
            { row1: 'Brand:', row2: 'Honeywell' },
            { row1: 'Function:', row2: 'Wireless Signal Repeater' },
            { row1: 'Connectivity:', row2: 'Wireless' },
            { row1: 'Color:', row2: 'White' },
            { row1: 'Mounting:', row2: 'Wall or Celling' },
            { row1: 'Power Supply:', row2: 'AC Adapter with Battery Backup' },
            { row1: 'Battery Type:', row2: 'Rechargeable' },
            { row1: 'Wireless Range:', row2: 'Extends up to 300+ Feet (Open Air)' },
            { row1: 'Dimensions:', row2: '6.0 x 4.0 x 1.5 inches' },
            { row1: 'Tamperproof:', row2: 'Yes' },
            { row1: 'Approvals and Standards:', row2: 'ETL Listed, FCC Certified' },
        ],
        info: [
            {
                header: 'Reliable Signal Extension for Large Installations',
                text: 'The PROSIXRPTR is a wireless repeater designed to extend the communication range of Honeywell ProSeries security devices. Ideal for large homes, multi-level buildings, or environments with signal interference.',
                section: [
                    { title: "Enhanced Range" },
                    { text: "Extends the reach of compatible wireless devices by retransmitting their signals to the main control panel, helping eliminate dead zones." },

                    { title: "Seamless Integration" },
                    { text: "Integrates effortlessly with Honeywell ProSeries systems without additional configuration — the repeater automatically identifies and supports signal boosting." },

                    { title: "Dual Power Options" },
                    { text: "Powered by an AC adapter with a built-in rechargeable battery for uninterrupted performance even during power outages." },

                    { title: "Secure and Tamper-Resistant" },
                    { text: "Includes tamper protection to alert the system if the repeater is moved or opened." }
                ]
            },

            {
                header: 'How does it work?',
                text: 'The PROSIXRPTR receives wireless signals from ProSeries devices and retransmits them, effectively doubling the coverage area and improving reliability in complex environments.',
                section: [
                    { title: "Signal Relay" },
                    { text: "Acts as a bridge by picking up weak or distant device signals and resending them to the control panel." },

                    { title: "Automatic Detection" },
                    { text: "Works transparently in the background—once installed, it automatically boosts signal strength for registered devices." },

                    { title: "Failsafe Power" },
                    { text: "Runs on AC power with automatic battery backup to ensure communication continuity." }
                ]
            },

            {
                header: 'Where to place it?',
                text: 'Placement of the PROSIXRPTR is key to maximizing its effectiveness in enhancing signal coverage.',
                section: [
                    { title: "Midpoint Placement" },
                    { text: "Install the repeater roughly halfway between the device(s) with weak signals and the main panel to ensure optimal communication relay." },

                    { title: "Avoid Barriers" },
                    { text: "Place the repeater away from thick concrete walls or metal obstructions that could block wireless signals." },

                    { title: "Accessible Power" },
                    { text: "Ensure it is installed near an electrical outlet and mounted securely for stable operation." }
                ]
            },

            {
                header: 'Common issues and troubleshooting',
                text: 'Common issues with wireless repeaters and how to troubleshoot them for continued performance.',
                section: [
                    { title: "No Signal Boost" },
                    { text: "Check device placement. Ensure it's within range of both the control panel and the connected devices." },

                    { title: "Power Failures" },
                    { text: "Verify the AC adapter is plugged in and the outlet is working. Check that the backup battery is charging." },

                    { title: "Tamper Alerts" },
                    { text: "Ensure the repeater is properly mounted and the cover is securely closed to prevent tamper triggers." },

                    { title: "Interference Issues" },
                    { text: "Reduce interference by relocating away from large appliances, routers, or thick walls." }
                ]
            },
        ]
    };
    return device;
};

export default PROSIXRPTR;
